import React from 'react';
import '../App.css';
import Cards from './Cards/Cards'; 
import Footer from './pages/Footer/Footer';

function Home () {
    return (
  <> 

 <Cards/>
 <Footer/>

    </>
    );
}

export default Home;
